import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./WspSidebarOverlay.less');
const cx = classnames.bind(styles);

@observer
export class WspSidebarOverlay extends React.Component<any, any>
{
    private _onClickOverlay = (e:React.MouseEvent<HTMLElement>) =>
    {
        controllers.ui.mainPage.toggleMobileMenuVisibility();
    };

    render():JSX.Element
    {
        const {isMobileMenuVisible} = rootState.ui.mainPage;

        return (
            <div
                className={cx(styles.sidebarOverlay, {isVisible: isMobileMenuVisible})}
                onClick={this._onClickOverlay}
            />
        );
    }
}
